import { getEnumValues } from './get-enum-values';
export enum RecruitingResponse{
	Yes='yes',
	No='no',
	Maybe='maybe',
	Seen='seen',
}
export const RecruitingResponseValues = getEnumValues<RecruitingResponse>(RecruitingResponse);
